<template>
  <KycDesktop
    :ratio="1"
    :subtitle="$t('Kyc thanks')"
    :no-buttons="true"
    title="Kerala Ventures"
    @next="next"
  >
    <div class="mb-6">
      <img src="../../../assets/completed-documents.svg">
    </div>
    <BaseParagraph class="mb-8">
      {{ $t('Kerala team review') }}
    </BaseParagraph>
    <div class="flex justify-between">
      <BaseButton
        :title="$t('Back')"
        theme="secondary"
        to="/kyc/desktop/attachments"
      />
      <BaseButton
        :title="$t('Next')"
        to="/opportunities"
      />
    </div>
  </KycDesktop>
</template>

<script>
import { mapActions } from 'vuex';
import KycDesktop from '../Desktop.vue';
import BaseParagraph from '../../../components/BaseParagraph.vue';
import BaseButton from '../../../components/BaseButton.vue';

export default {
  name: 'Success',
  components: {
    KycDesktop,
    BaseParagraph,
    BaseButton,
  },
  created() {
    this.submit();
    this.fetch();
  },
  methods: {
    ...mapActions('kyc', ['submit', 'fetch']),
    next() {
      this.$router.push('/opportunities');
    },
  },
};
</script>
